module.exports = __webpack_public_path__ + "img/pc_main_bg.087578a.webp";